<script setup lang="ts">
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

withDefaults(
  defineProps<{
    searchStateMsg?: string
    emptyStateMsg?: string
    isSearchState?: boolean
  }>(),
  {
    isSearchState: false,
    searchStateMsg: 'No results found',
    emptyStateMsg: 'No items found',
  },
)
</script>
<template>
  <BoxComponent :pl="16" :pr="16" :pt="48" :pb="48">
    <BoxComponent v-if="isSearchState" :mb="48">
      <TypographyComponent variant="body-large" color="var(--secondary-48)" text-align="center">
        {{ searchStateMsg }}
      </TypographyComponent>
    </BoxComponent>
    <BoxComponent v-else :mb="48">
      <FlexComponent direction="column" align="center" :gap="24">
        <TypographyComponent variant="body-large" color="var(--secondary-48)" text-align="center">
          {{ emptyStateMsg }}
        </TypographyComponent>
        <slot name="cta" />
      </FlexComponent>
    </BoxComponent>
  </BoxComponent>
</template>
